import { render, staticRenderFns } from "./BrokerAccountDetails.vue?vue&type=template&id=060f2efc&scoped=true"
import script from "./BrokerAccountDetails.vue?vue&type=script&lang=js"
export * from "./BrokerAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./BrokerAccountDetails.vue?vue&type=style&index=0&id=060f2efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060f2efc",
  null
  
)

export default component.exports